export const renderPaymentBrick = async (bricksBuilder, store) => {
  let amount = store.getters.CheckoutTotal01
  const settings = {
    initialization: {
      /*
        "amount" é a quantia total a pagar por todos os meios de pagamento com exceção da Conta Mercado Pago e Parcelas sem cartão de crédito, que têm seus valores de processamento determinados no backend através do "preferenceId"
      */
      amount: Number((amount).toFixed(2)),
      payer: {
        firstName: "",
        lastName: "",
        email: "",
      },
    },
    customization: {
      visual: {
        hideFormTitle: false,
        hidePaymentButton: true,
        style: {
          theme: "default",
        },
      },
      paymentMethods: {
        creditCard: "all",
				debitCard: "all",
				bankTransfer: "all"
      },
    },
    callbacks: {
      onReady: () => {
        /*
         Callback chamado quando o Brick está pronto.
         Aqui, você pode ocultar seu site, por exemplo.
        */
      },
      onError: (error) => {
        // callback chamado para todos os casos de erro do Brick
        console.error(error)
      },
    },
  }

  window.paymentBrickController = await bricksBuilder.create(
    "payment",
    "paymentBrick_container",
    settings
  )
}
